import { Alert, AlertDescription, Box, Spinner, Stack } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import { useLocation } from 'react-router-dom';
import InvoicePDFButton from '../../../../components/PDFs/DownloadPDFButton/invoiceButton';
import { TextS } from '../../../../components/Text/Index';
import { useContext } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';
import PaymentReissueMobilePage from './mobile';

const PaymentReissue: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);
  const registrationId = useLocation().pathname.split('/')[3];
  const getRegistration = useGetRegistration(registrationId || '');

  if (isMobile) return <PaymentReissueMobilePage />;

  return (
    <MainCard title="ÁREA DO CANDIDATO - " subtitle="FORMA DE PAGAMENTO">
      {getRegistration?.isLoading ? (
        <Stack px={['10px', '10px', '10px', '50px', '50px']}>
          <Spinner />
        </Stack>
      ) : (
        <Box height="100%" overflow={'auto'} px={['10px', '10px', '10px', '50px', '50px']}>
          {getRegistration.data?.candidate.is_foreign ? (
            <Alert variant="top-accent" status="info">
              <AlertDescription
                px={2}
                dangerouslySetInnerHTML={{
                  __html:
                    getRegistration.data?.selective_process_vacancy?.selective_process?.information_foreign_payment ||
                    'No momento não foi adicionado nenhuma informação para pagamento.',
                }}
              ></AlertDescription>
            </Alert>
          ) : (
            <>
              <TextS>
                <strong>Atenção!</strong> Sua inscrição somente será efetivada após a confirmação do pagamento da taxa
                de inscrição.
              </TextS>
              <TextS>
                <strong>Valor da inscrição: </strong> R${' '}
                {getRegistration.data?.selective_process_vacancy?.value || '--'}
              </TextS>

              <InvoicePDFButton registrationId={registrationId || ''} />
            </>
          )}
        </Box>
      )}
    </MainCard>
  );
};

export default PaymentReissue;
